/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type tradeGeneralOnboardingQueryVariables = {
    readonly userId: string;
};
export type tradeGeneralOnboardingQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly verifiedTradeSubStatus: string | null;
        } | null;
    } | null;
};
export type tradeGeneralOnboardingQuery = {
    readonly response: tradeGeneralOnboardingQueryResponse;
    readonly variables: tradeGeneralOnboardingQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "verifiedTradeSubStatus",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "tradeGeneralOnboardingQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "tradeGeneralOnboardingQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        },
                        (v3 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "tradeGeneralOnboardingQuery",
            "id": "ferrum/234.0.0-2019-09-26T17:57:22.088Z/tradeGeneralOnboardingQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '64ddc90929301867e13b3c6be16fd328';
export default node;
